import React, { createContext, useContext, useMemo, useState } from "react";
import { useLoaderData } from "react-router-dom";

import { AsyncStatuses } from "../../../../../types/shared";
import { RatingsContextProps, RatingsContextValues } from "../types/contexts";
import { ITeamRating } from "../types/ratings";

const RatingsContext = createContext<RatingsContextValues | null>(null);

export const useRatingsContext = () => {
    const context = useContext(RatingsContext);
    if (!context) {
        throw new Error(
            "useRatingsContext must be used within a RatingsProvider",
        );
    }
    return context;
};

export const RatingsProvider: React.FC<RatingsContextProps> = props => {
    const { children } = props;
    const { teamId, ratings: loadedRatings } = useLoaderData() as {
        teamId: number;
        ratings: ITeamRating[];
    };

    const [fetchStatus, setFetchStatus] = useState<AsyncStatuses>("init");
    const [ratings, setRatings] = useState<ITeamRating[]>(loadedRatings);

    const contextValue = useMemo(
        () => ({
            fetchStatus,
            setFetchStatus,
            ratings,
            setRatings,
            teamId,
        }),
        [ratings, fetchStatus],
    );

    return (
        <RatingsContext.Provider value={contextValue}>
            {children}
        </RatingsContext.Provider>
    );
};
